"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { analytics } from "@/lib/analytics/segment";

export function SegmentPageTracker() {
  const pathname = usePathname();

  useEffect(() => {
    analytics.page();
  }, [pathname]);

  return null;
}
